<template>
  <div>
    <van-picker
      show-toolbar
      :columns="columns"
      @confirm="onConfirm"
      @cancel="cancel"
    />
  </div>
</template>

<script>
export default {
  name:'Picker',
  props:['columns'],
  methods:{
    onConfirm(val){
     this.$emit('confirmPicker',{
        data: this.data,
        value: val,
        showPicker:false
      })
    },
    cancel(){
      this.$emit('cancelPicker',{
        showPicker:false
      })
    }
  }
};
</script>

<style>

</style>